import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ShieldCheck, MonitorPlay, Moon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="text-amber" size={32} data-id="element-165" />,
    title: "Guía Digital 'Gato de Depto. Feliz'",
    desc: 'El paso a paso para hackear tu casa.'
  }, {
    icon: <ShieldCheck className="text-amber" size={32} data-id="element-166" />,
    title: 'Protocolo Anti-Uñas',
    desc: 'Cómo salvar el sillón en las primeras 24 horas.'
  }, {
    icon: <div className="text-amber" size={32} data-id="element-167" />,
    title: 'Arquitectura de Cartón',
    desc: 'Planos para armar castillos y túneles con cajas de súper.'
  }, {
    icon: <MonitorPlay className="text-amber" size={32} data-id="element-168" />,
    title: 'TV para Gatos',
    desc: 'Cómo asegurar tus ventanas y balcones de forma económica y segura en Argentina.'
  }, {
    icon: <Moon className="text-amber" size={32} data-id="element-169" />,
    title: 'Ritual del Sueño',
    desc: 'El truco de 10 minutos para que tu gato no te despierte a la madrugada.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-cream" data-id="element-170">
      <div className="max-w-5xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl mb-4" data-id="element-173">¿Qué te llevás hoy?</h2>
          <p className="text-xl text-warmBrown/70" data-id="element-174">
            Todo lo que necesitás para transformar tu departamento.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-175">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-cream" data-id="element-176">
              <div className="mb-6 bg-cream w-16 h-16 rounded-2xl flex items-center justify-center" data-id="element-177">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-178">{item.title}</h3>
              <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-179">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}